module.exports = __webpack_public_path__ + "static/media/filebox-logo1.534be2c3.png";